export default {
    ADD_USER_PRIVILEGES_MODAL: {
        TITLE: 'Share contact with a user',
        SELECT: 'Select a user',
        PERMISSION: 'This user has permissions to...',
    },

    ADD_GROUP_PRIVILEGES_MODAL: {
        TITLE: 'Share contact with a group',
        SELECT: 'Select a group',
        PERMISSION: 'This group has permissions to...',
    },

    ADD_USER_BUTTON: 'Share with user',
    ADD_GROUP_BUTTON: 'Share with group',

    READ_PERMISSION: 'View only',
    WRITE_PERMISSION: 'View and edit',

    TAB_HEADER: 'Access privileges',
    GROUP_EMPTY_TABLE_LABEL: 'This contact record has not been shared with any groups',
    GROUP_SHARING: 'Shared groups',
    USER_EMPTY_TABLE_LABEL: 'This contact record has not been shared with any users',
    USER_SHARING: 'Shared users',
};
